import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { CALCULATORS, PAGE_BANNERS, heroStyle } from "../data/site";

function CalculatorsPage() {
  return (
    <>
      <section className="fi-hero" style={{ padding: "6.5rem 0", ...heroStyle(PAGE_BANNERS.calculators) }}>
        <Container>
          {/* <Link to="/" className="text-white-50">← Home</Link> */}
          <h1 className="mt-2">Finance Calculators</h1>
          <p className="lead mb-0">
            Free, accurate and instant plan your SIPs, loans, taxes and savings.
          </p>
        </Container>
      </section>

      <Container className="py-5">
        <Row className="g-4">
          {CALCULATORS.map((c) => (
            <Col md={6} lg={4} key={c.slug}>
              <Card
                as={Link}
                to={`/calculators/${c.slug}`}
                className="fi-calc-card text-decoration-none text-reset"
                style={{ "--c": c.color }}
              >
                <Card.Body>
                  <div className="fi-card-icon">{c.emoji}</div>
                  <Card.Title className="fw-bold">{c.title}</Card.Title>
                  <Card.Text className="text-muted">{c.desc}</Card.Text>
                  <span className="fw-semibold fi-open">Open calculator →</span>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
}

export default CalculatorsPage;
